import React from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import LaboratoryResultsToDescribeList from '../LaboratoryResultsToDescribeList/LaboratoryResultsToDescribeList';
import styles from './LaboratoryResultsToDescribeWrapper.module.scss';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { LaboratoryResultMiseStatus } from '../../../../graphql/graphql';

const LaboratoryResultsToDescribeWrapper: React.FC = () => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.laboratoryResultsToDescribeWrapper.all',
			key: 'all',
			component: (params: NavigationStepperComponentParams) => (
				<LaboratoryResultsToDescribeList
					filter={{ my: false, status: LaboratoryResultMiseStatus.New }}
					key='all'
				/>
			),
		},
		{
			name: 'component.laboratoryResultsToDescribeWrapper.mineToDescribe',
			key: 'mineToDescribe',
			component: (params: NavigationStepperComponentParams) => (
				<LaboratoryResultsToDescribeList
					filter={{ my: true, status: LaboratoryResultMiseStatus.Assigned }}
					key='mineToDescribe'
				/>
			),
		},
		{
			name: 'component.laboratoryResultsToDescribeWrapper.describedByMe',
			key: 'describedByMe',
			component: (params: NavigationStepperComponentParams) => (
				<LaboratoryResultsToDescribeList
					filter={{ my: true, status: LaboratoryResultMiseStatus.Done }}
					key='describedByMe'
				/>
			),
		},
	];

	return (
		<div className={styles.wrapper}>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='all'
				canSkip={true}
			/>
		</div>
	);
};

export default LaboratoryResultsToDescribeWrapper;
